import(/* webpackMode: "eager" */ "/home/u573935505/domains/shaairabiocare.com/hbuilds/source/components/ManufacturingGuide.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["SiteFooter"] */ "/home/u573935505/domains/shaairabiocare.com/hbuilds/source/components/SiteFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteHeader"] */ "/home/u573935505/domains/shaairabiocare.com/hbuilds/source/components/SiteHeader.tsx");
;
import(/* webpackMode: "eager" */ "/home/u573935505/domains/shaairabiocare.com/hbuilds/source/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/u573935505/domains/shaairabiocare.com/hbuilds/source/node_modules/next/dist/client/image-component.js");
